import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import css from './RenderFeaturedListings.module.css';
import Slider from 'react-slick';

import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';

import { ListingCard } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { searchListings } from '../../SearchPage/SearchPage.duck';
import { useConfiguration } from '../../../context/configurationContext';
import { getListingsById } from '../../../ducks/marketplaceData.duck';
import { cardRenderSizes, getFeaturedListings, getSearchParams } from '../../../util/genericHelpers';

function RenderFeaturedListings() {
  const intl = useIntl();
  const config = useConfiguration();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  // Use narrow, stable selectors — never select the entire state object
  const marketplaceData = useSelector(state => state.marketplaceData);
  const currentPageResultIds = useSelector(
    state => state.SearchPage.currentPageResultIds
  );

  // Build a pseudo-state object only with what getListingsById needs
  const stateForSelector = { marketplaceData };
  const listings = getListingsById(stateForSelector, currentPageResultIds);
  const featuredListings = getFeaturedListings(listings);

  // Guard with a ref so this only fires once per mount, not on every render
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    dispatch(
      searchListings({
        searchParams: {
          ...getSearchParams(),
          perPage: 100,
          include: ['author', 'images'],
        },
        config,
      })
    );
  }, [dispatch, config]);

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1128, settings: { slidesToShow: 4 } },
      { breakpoint: 991, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      {featuredListings?.length ?
        <div className={css.sectionLocations}>
          <div className={css.fixedWidthContainer}>
            <div className={css.sectionHead}>
              <div className={css.leftSec}>
                <h2>
                  {intl.formatMessage({
                    id: 'RenderFeaturedLocations.heading',
                    defaultMessage: 'Our most unique featured products',
                  })}
                </h2>
                <p>
                  {intl.formatMessage({
                    id: 'RenderFeaturedLocations.subheading',
                    defaultMessage:
                      'Most liked and popular, unique, thrilling and listed on our customer’s top picks.',
                  })}
                </p>
              </div>
            </div>

            <div className={css.categorySlider}>
              <Slider {...sliderSettings}>
                {featuredListings.map(l => (
                  <ListingCard
                    className={css.listingCard}
                    key={l.id.uuid}
                    listing={l}
                    renderSizes={cardRenderSizes(false)}
                    setActiveListing={() => { }}
                    isFeatured={true} 
                  />
                ))}
              </Slider>
            </div>
          </div>
        </div> : null
      }
    </>

  );
}

export default RenderFeaturedListings;
